import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Calendar, Info, ShieldCheck, BookOpen, Target } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function PermitToCarry() {
  useDocumentMeta('Minnesota Permit to Carry Classes | Kjergaard Sports', 'Information on Minnesota Permit to Carry classes offered at Kjergaard Sports in Lake Benton, Minnesota.');
  return <div data-id="element-644">
      <PageHero title="Minnesota Permit to Carry Classes" image="https://cdn.magicpatterns.com/uploads/916kAQgnnbRYFKKSKvhkwD/targets-shooting-supplies.jpg" alt="Targets and shooting supplies at Kjergaard Sports" data-id="element-645" />

      <section className="py-20 bg-brand-offwhite" data-id="element-646">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-647">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-648">
            <Calendar className="w-12 h-12 text-brand-hunter mx-auto mb-6" data-id="element-649" />
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-650">
              Class Information
            </h2>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-651">
              Kjergaard Sports periodically hosts Minnesota Permit to Carry
              classes. These in-person sessions cover essential safety
              fundamentals, legal requirements, and practical instruction for
              responsible carry.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-652">
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream text-center" data-id="element-653">
              <ShieldCheck className="w-10 h-10 text-brand-leather mx-auto mb-4" data-id="element-654" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-655">
                Safety First
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-656">
                Learn the core principles of safe firearm handling, storage, and
                situational awareness.
              </p>
            </div>
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream text-center" data-id="element-657">
              <BookOpen className="w-10 h-10 text-brand-leather mx-auto mb-4" data-id="element-658" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-659">
                Legal Knowledge
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-660">
                Understand the laws and responsibilities associated with
                carrying a firearm in Minnesota.
              </p>
            </div>
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream text-center" data-id="element-661">
              <Target className="w-10 h-10 text-brand-leather mx-auto mb-4" data-id="element-662" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-663">
                Practical Skills
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-664">
                Receive hands-on instruction to build confidence and proficiency
                with your firearm.
              </p>
            </div>
          </div>

          <div className="max-w-3xl mx-auto" data-id="element-665">
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-666">
              <div className="flex items-start" data-id="element-667">
                <Info className="w-6 h-6 text-brand-leather mr-4 flex-shrink-0 mt-1" data-id="element-668" />
                <div data-id="element-669">
                  <h3 className="font-serif text-xl mb-2" data-id="element-670">Schedule Updates</h3>
                  <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-671">
                    Class dates change. Please call Kjergaard Sports or follow
                    our Facebook page for the current class schedule, pricing,
                    and registration details.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-brand-cream border-l-4 border-brand-leather p-6" data-id="element-672">
              <p className="text-brand-charcoal/90 text-sm leading-relaxed" data-id="element-673">
                <strong data-id="element-674">Legal Disclaimer:</strong> Information provided in
                classes is for educational purposes and does not constitute
                legal advice. Obtaining a permit is subject to meeting all state
                and federal requirements. Kjergaard Sports does not guarantee
                permit approval.
              </p>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-675" />
    </div>;
}